import { createSlice } from "@reduxjs/toolkit";

export const paymentCategoriesSlice = createSlice({
  name: "paymentCategories",
  initialState: {
    categories: [],
  },
  reducers: {
    setPaymentCategories: (state, action) => {
      state.categories = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setPaymentCategories } = paymentCategoriesSlice.actions;

export default paymentCategoriesSlice.reducer;
